var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletConnectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 387.8 238",
    style: {
      enableBackground: "new 0 0 387.8 238"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WalletConnect&apos;s logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "WalletConnect_1_",
    className: "st0",
    d: "M79.5,46.5c63.2-61.9,165.7-61.9,228.9,0L316,54c3.2,3.1,3.2,8.1,0,11.2l-26,25.5 c-1.6,1.5-4.1,1.5-5.7,0l-10.5-10.3c-44.1-43.2-115.6-43.2-159.7,0l-11.2,11c-1.6,1.5-4.1,1.5-5.7,0l-26-25.5 c-3.2-3.1-3.2-8.1,0-11.2L79.5,46.5z M362.2,99.2l23.2,22.7c3.2,3.1,3.2,8.1,0,11.2L281,235.4c-3.2,3.1-8.3,3.1-11.4,0l0,0 l-74.1-72.6c-0.8-0.8-2.1-0.8-2.9,0l0,0l-74.1,72.6c-3.2,3.1-8.3,3.1-11.4,0l0,0L2.5,133.1c-3.2-3.1-3.2-8.1,0-11.2l23.2-22.7 c3.2-3.1,8.3-3.1,11.4,0l74.1,72.6c0.8,0.8,2.1,0.8,2.9,0l0,0l74.1-72.6c3.2-3.1,8.3-3.1,11.4,0l0,0l74.1,72.6 c0.8,0.8,2.1,0.8,2.9,0l74.1-72.6C354,96.1,359.1,96.1,362.2,99.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnectIcon);
export default __webpack_public_path__ + "static/media/WalletConnect-icon.a959d0a3.svg";
export { ForwardRef as ReactComponent };